import React, { useEffect } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function Fancybox(props) {
  
  const delegate = props.delegate || "[data-fancybox]";
  useEffect(() => {
    const opts = props.options || {};
    NativeFancybox.bind(delegate, opts);
    return () => {
      NativeFancybox.destroy();
    };

  }, []);

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
      // For mobile view, initialize Fancybox on the mobile image
      Fancybox.bind('.mobile-img', {
        caption: function (fancybox, slide) {
          return slide.caption;
        }
      });
    } else {
      // For desktop view, initialize Fancybox on the desktop image
      Fancybox.bind('.desktop-img', {
        caption: function (fancybox, slide) {
          return slide.caption;
        }
      });
    }
  })

  return (
    <>
      {props.children}
    </>
  )
  
}

export default Fancybox;
 